import { LEADING_PANE_MIN_WIDTH } from "../screen-layout";

/** The narrowest either pane can be dragged to. */
export const PANE_MIN_WIDTH = LEADING_PANE_MIN_WIDTH;

const STORAGE_KEY = "twoPaneSplit";

/** The leading pane's share of the panes' width the user chose, or null for the default split. */
export function readPaneSplit(): number | null {
  try {
    const stored = Number(localStorage.getItem(STORAGE_KEY));
    return stored > 0 && stored < 1 ? stored : null;
  } catch {
    return null;
  }
}

/** Saves the leading pane's share, or forgets it with null. */
export function writePaneSplit(split: number | null) {
  try {
    if (split === null) localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, String(split));
  } catch {
    // Storage is unavailable; the split lasts until the page reloads.
  }
}

/** Whether panes this wide leave room to move the split at all. */
export const canSplit = (width: number) => width >= PANE_MIN_WIDTH * 2;

/** A leading pane width kept within reach of both panes' minimum. */
export const clampLeadingWidth = (leading: number, width: number) =>
  Math.min(Math.max(leading, PANE_MIN_WIDTH), width - PANE_MIN_WIDTH);

/** The leading pane's width in px for a saved share, or null for the default split. */
export function leadingWidthFor(split: number | null, width: number): number | null {
  if (split === null || !canSplit(width)) return null;
  return Math.round(clampLeadingWidth(split * width, width));
}
